import React from 'react'
import { Typography, Box} from "@mui/material";
import Colors from '../../Constant/Colors';

function Header({title,subtitle}) {
  return (
    <Box mb="30px" m="0px"  >
    <Typography
      variant="h5"
      color={Colors.gray}
      fontWeight="bold"
      sx={{ m: "0 0 5px 0" }}
    >
      {title}
    </Typography>
    <Typography variant="h6" color={"#32325d"}>
      {subtitle}
    </Typography>
  </Box>
  )
}

export default Header